import { RFIItem } from '@/types/rfiItem';

export const mockRFIItems: RFIItem[] = [
  {
    id: '1',
    ref: '1.01',
    priority: 'Medium',
    status: 'Open',
    date: '10/06/2025',
    area: 'Legal structure',
    documentRef: '[n/a]',
    request: 'The current legal structure of the target group showing:\n- all existing group entities, including dormant entities\n- entity type (e.g. partnership, trust) and location\n- any changes in the ownership structure during the Historical Period\n- share ownership of the parent company.',
    managementComment: '',
    advisorNotes: '',
    category: 'Business context'
  },
  {
    id: '2',
    ref: '1.02',
    priority: 'High',
    status: 'Closed',
    date: '10/06/2025',
    area: 'Accounting policies',
    documentRef: 'DOC-002',
    request: 'Details of any accounting policy changes which may have occurred over the Historical Period. To include the date of change in policy, how it was adopted, and consideration of the impact on the accounts.',
    managementComment: 'Documentation provided. Note: reconciliation variance of NZ $45,000 identified in FY24 due to policy change implementation timing.',
    advisorNotes: '',
    category: 'Business context'
  },
  {
    id: '3',
    ref: '1.03',
    priority: 'Medium',
    status: 'In Progress',
    date: '10/06/2025',
    area: 'Preparation of accounts',
    documentRef: 'DOC-001',
    request: 'Description of process, systems and people involved in preparing management accounts and the financial statements.',
    managementComment: 'Full documentation provided via dataroom. Reconciliation variance of NZ $12,500 noted between management accounts and statutory accounts due to timing differences.',
    advisorNotes: '',
    category: 'Business context'
  },
  {
    id: '4',
    ref: '2.01',
    priority: 'Critical',
    status: 'Closed',
    date: '10/06/2025',
    area: 'Historical trial balances (GL detail)',
    documentRef: 'DOC-003',
    request: 'Trial balances (GL level detail) downloaded from the accounting system from April 2022 to April 2025.',
    managementComment: 'Trial balances provided. Reconciliation variance of NZ $8,200 identified in April 2024 period due to system migration.',
    advisorNotes: '',
    category: 'Historical trading'
  },
  {
    id: '5',
    ref: '2.02',
    priority: 'Critical',
    status: 'Closed',
    date: '10/06/2025',
    area: 'Historical management accounts',
    documentRef: 'DOC-004',
    request: '(i) To the extent that they differ from the trial balance downloads, please provide management accounts including monthly income statements, monthly balance sheets and monthly cash flow statements from April 2022 to April 2025.\n(ii) Mapping between the trial balance GL codes and management accounts.',
    managementComment: 'Management accounts and mapping provided. Reconciliation variance of NZ $23,400 between trial balance and management accounts relates to reclassification of certain expense categories.',
    advisorNotes: '',
    category: 'Historical trading'
  },
  {
    id: '6',
    ref: '2.03',
    priority: 'Medium',
    status: 'Open',
    date: '10/06/2025',
    area: 'Quality of earnings',
    documentRef: '[n/a]',
    request: 'Analysis of any earnings adjustments identified (e.g. one-off income or expenses, non-operating income or expenses) including back up support and workings for each adjustment.',
    managementComment: 'Not applicable for this transaction',
    advisorNotes: '',
    category: 'Historical trading'
  }
];
